import { HeartHandshake, ShieldCheck, Sparkles } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Viajes Seguros",
    text: "Arneses y cinturones de seguridad certificados para que tu peludo viaje protegido de principio a fin.",
  },
  {
    icon: Sparkles,
    title: "Higiene Total",
    text: "Sanitizamos la unidad antes y después de cada viaje. Un espacio limpio, fresco y libre de estrés.",
  },
  {
    icon: HeartHandshake,
    title: "Conductores Pet-Friendly",
    text: "Conductores capacitados en manejo animal que tratan a tu mejor amigo como a uno de los nuestros.",
  },
];

export function Features() {
  return (
    <section id="como-funciona" className="py-20 sm:py-24">
      <div className="mx-auto max-w-6xl px-5">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-display text-3xl font-bold tracking-tight text-primary sm:text-4xl">
            ¿Por qué viajar con PetMoon?
          </h2>
          <p className="mt-4 text-lg text-muted-foreground">
            Cada detalle está pensado para que tu mascota viaje tan cómoda como lo haría
            contigo.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {features.map((feature) => (
            <article
              key={feature.title}
              className="rounded-3xl bg-card p-8 shadow-soft ring-1 ring-border transition-transform duration-300 hover:-translate-y-1.5"
            >
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gold-soft">
                <feature.icon className="h-7 w-7 text-gold-deep" aria-hidden />
              </span>
              <h3 className="mt-6 font-display text-xl font-bold text-foreground">
                {feature.title}
              </h3>
              <p className="mt-3 leading-relaxed text-muted-foreground">{feature.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
